/**TODAS LAS VARIABLES GLOBALES QUE SE UTILIZAN PARA LA AUTENTICACIÓN */
export const SITA = "https://sgc.talleravellaneda.com.ar";
export const API_AUTH = "https://sgc.talleravellaneda.com.ar/auth.php";
//login
//logout
//loged

export const API_USER = "https://sgc.talleravellaneda.com.ar/users.php";
//lista-usuarios
//ver-usuario
//nuevo-usuario
//modificar-usuario
//eliminar-usuario